/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

function createCartUpdateEvent(promise, variantId) {
  const cartEvent = new Event('shopify:cart:lines-update', { bubbles: true });
  cartEvent.action = 'add';
  cartEvent.context = 'product';
  cartEvent.lines = [{ merchandiseId: variantId, quantity: 1 }];
  cartEvent.promise = promise;
  return cartEvent;
}

async function addVariantAndOpenDrawer(link, variantId) {
  const cartUpdatePromise = (async () => {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section',
      }),
    });

    const addData = await addResponse.json();
    if (!addResponse.ok || addData.status) {
      throw new Error(addData.message || 'Unable to add item to cart');
    }

    const cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    const cart = await cartResponse.json();

    return {
      cart: {
        totalQuantity: cart.item_count,
      },
      detail: {
        didError: false,
        itemCount: 1,
        items: cart.items,
        sections: addData.sections || {},
        source: 'media-story-card',
      },
    };
  })();

  link.dispatchEvent(createCartUpdateEvent(cartUpdatePromise, variantId));
  await cartUpdatePromise;

  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer?.open) drawer.open();
}

document.addEventListener(
  'click',
  (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href*="/cart/add"][href*="id="]') : null;
    if (!(link instanceof HTMLAnchorElement) || !link.closest('.media-with-content, .lp-diplomat-story')) return;

    const url = new URL(link.href, window.location.origin);
    const variantId = url.searchParams.get('id');
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');

    addVariantAndOpenDrawer(link, variantId)
      .catch((error) => {
        console.warn('[media-story-card] Add to cart failed', error);
      })
      .finally(() => {
        link.removeAttribute('aria-busy');
      });
  },
  true
);

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
